import {
  ENTITIES_SORT_OPTIONS,
  ENTITIES_FILTER_OPTIONS,
} from 'constants/entitiesOptions';
import initialListState from 'store/hoReducers/paginatedList/initialState';

export default {
  ...initialListState,
  list: {
    ...initialListState.list,
    sortOptions: ENTITIES_SORT_OPTIONS,
    filterOptions: ENTITIES_FILTER_OPTIONS,
    paginationOptions: {
      ...initialListState.list.paginationOptions,
      archived: '',
      imported_from_xpack: '',
    },
    filterParams: {},
  },
};
